export function handleApiErrors(data: any, toastService: { showError: (msg: string) => void }) {
    const errors = data?.response?.data?.errors;
    if (errors && typeof errors === "object") {
        Object.keys(errors).forEach(field => {
            const fieldErrors = errors[field];
            if (Array.isArray(fieldErrors)) {
                toastService.showError(`${field}: ${fieldErrors[0]}`);
            } else {
                toastService.showError(`${field}: ${fieldErrors}`);
            }
        });
    } else {
        // Handle string or object error messages from backend
        let errorMessage = "";
        const responseData = data?.response?.data;
        if (typeof responseData === "string") {
            errorMessage = responseData;
        } else if (typeof responseData === "object" && responseData !== null) {
            errorMessage =
                responseData.message ||
                responseData.error ||
                data?.message ||
                JSON.stringify(responseData);
        } else {
            errorMessage = data?.message || JSON.stringify(data);
        }
        toastService.showError(errorMessage.toString());
    }    
}